import { axios } from '@vyce/core/src/api';
import config from '../config';

const URL = `${config.storageApiUrl}`;

export const saveAvatarRequest = (file: File, token: string, uuid: string) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  bodyFormData.append('title', 'avatar');
  return axios.post(`/storage/user/${uuid}/media/albums/default/photos`, bodyFormData);
};

export const uploadFileRequest = (file: File) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  return axios.post(`${URL}/documents`, bodyFormData);
};
